import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import BaseViewModel from "./../factories/base-view-model";
import TreeNodeViewModel from "./../factories/tree-node";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import "./../bindings/bao-tree";
function TicketCategoryDialogViewModel(tabPage) {
    var self = this;
    self.Category = ko.observable();
    self.Category1 = ko.observable();
    self.Category2 = ko.observable();
    self.Category3 = ko.observable();
    self.Category4 = ko.observable();
    self.Category5 = ko.observable();
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.Category1, self.Category2, self.Category3, self.Category4, self.Category5);
        tabPage.IsLoading(true);
        translateDialog.Open().then(function () {
            tabPage.IsLoading(false);
        });
    };
    self.CategoryComputed = ko.computed(function () {
        self.Category1();
        self.Category2();
        self.Category3();
        self.Category4();
        self.Category5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Category(self.Category1());
                break;
            case 2:
                self.Category(self.Category2());
                break;
            case 3:
                self.Category(self.Category3());
                break;
            case 4:
                self.Category(self.Category4());
                break;
            case 5:
                self.Category(self.Category5());
                break;
        }
    });
    self.Category.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Category1(self.Category());
                break;
            case 2:
                self.Category2(self.Category());
                break;
            case 3:
                self.Category3(self.Category());
                break;
            case 4:
                self.Category4(self.Category());
                break;
            case 5:
                self.Category5(self.Category());
                break;
        }
    });
}
function TicketCategoryViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(this, tabPage);
    self.Nodes = ko.observableArray([]);
    self.SelectedNode = ko.observable();
    self.TicketTypeCategory = ko.observable();
    self.TicketTypeCategoryId = ko.observable();
    self.TicketTypeCategoryId.subscribe(function (item) {
        self.Refresh();
    });
    self.SelectedNode.subscribe(function () {
        self.ToggleButtons();
    });
    self.ToggleButtons = function () {
        var enabled = self.SelectedNode() != null;
        BaoMenu.permissionEnable({
            ActionKey: "TicketCategoryAdd",
            Enabled: enabled && self.SelectedNode().Level() < 4,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "TicketCategoryEdit",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "TicketCategoryDelete",
            Enabled: enabled,
            Context: tabPage.Context()
        });
    };
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketCategory");
    self.TicketCategoryDelete = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                Bao.post("TicketCategory/Delete", JSON.stringify({
                    ticketCategoryStructureId: self.SelectedNode().Tag()
                }), function () {
                    var newNodes = [];
                    var nodeCollection;
                    if (self.SelectedNode().Parent != null) {
                        nodeCollection = self.SelectedNode().Parent.Nodes;
                    }
                    else {
                        nodeCollection = self.Nodes;
                    }
                    $.each(nodeCollection(), function (index, item) {
                        if (item != self.SelectedNode()) {
                            newNodes.push(item);
                        }
                    });
                    nodeCollection(newNodes);
                    self.SelectedNode(null);
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.TicketCategoryAddRoot = function () {
        return Bao.post("TicketCategory/NewModel", JSON.stringify({
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, null);
            });
        });
    };
    self.TicketCategoryAdd = function () {
        return Bao.post("TicketCategory/NewModel", JSON.stringify({
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, self.SelectedNode().Tag());
            });
        });
    };
    self.Save = function (ticketCategory) {
        tabPage.IsLoading(true);
        self.SelectedNode().Text(ticketCategory.Category());
        return Bao.post("TicketCategory/Save", JSON.stringify({
            ticketCategory: ko.map.toJS(ticketCategory)
        }), function () {
            if (self.SelectedNode().Parent != null) {
                self.SortNodes(self.SelectedNode().Parent.Nodes);
            }
            else {
                self.SortNodes(self.Nodes());
            }
            tabPage.IsLoading(false);
        });
    };
    self.SaveNew = function (ticketCategory, parentTicketCategoryStructureId) {
        tabPage.IsLoading(true);
        return Bao.post("TicketCategory/SaveNew", JSON.stringify({
            ticketCategory: ko.map.toJS(ticketCategory),
            parentTicketCategoryStructureId: parentTicketCategoryStructureId
        }), function (node) {
            var newNode;
            if (parentTicketCategoryStructureId == null) {
                newNode = new TreeNodeViewModel(node);
                self.Nodes.push(newNode);
                self.SortNodes(self.Nodes);
                self.SelectedNode(newNode);
            }
            else {
                newNode = new TreeNodeViewModel(node, self.SelectedNode());
                self.SelectedNode().Nodes.push(newNode);
                self.SortNodes(self.SelectedNode().Nodes);
                self.SelectedNode(newNode);
            }
            tabPage.IsLoading(false);
        });
    };
    self.SortNodes = function (nodesArray) {
        nodesArray.sort(function (itemA, itemB) {
            var textA = itemA.Text().toLowerCase();
            var textB = itemB.Text().toLowerCase();
            return textA == textB ? 0 : textA < textB ? -1 : 1;
        });
    };
    self.ShowDialog = function (dialogDataSource, fn) {
        tabPage.IsLoading(true);
        Bao.get("TicketCategory/Dialog", function (dialogView) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        fn(dialog.ViewModel()).then(dialog.Close);
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            var dialogVM = new TicketCategoryDialogViewModel(tabPage);
            ko.map.fromJS(dialogDataSource, dialogVM);
            dialog.ViewModel(dialogVM);
            dialog.Template(dialogView);
            dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.TicketCategoryEdit = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketCategory/Edit", JSON.stringify({
            ticketCategoryStructureId: self.SelectedNode().Tag()
        }), function (editResult) {
            self.ShowDialog(editResult, function (editVM) {
                return self.Save(editVM);
            });
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        self.SelectedNode(null);
        return Bao.post("TicketCategory/Load", JSON.stringify({
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (value) {
            var newItems = [];
            if (value != null && value.length > 0) {
                $.each(value, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    newItems[index] = node;
                });
            }
            self.Nodes(newItems);
            tabPage.IsLoading(false);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "TicketCategoryAdd":
                    self.TicketCategoryAdd();
                    break;
                case "TicketCategoryEdit":
                    self.TicketCategoryEdit();
                    break;
                case "TicketCategoryDelete":
                    self.TicketCategoryDelete();
                    break;
                case "TicketCategoryAddRoot":
                    self.TicketCategoryAddRoot();
                    break;
                case "TicketCategoryRefresh":
                    self.Refresh();
                    break;
            }
        }
    }));
    self.loaded = function () {
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
        self.Refresh();
        self.ToggleButtons();
    };
}
Bao.inherit(TicketCategoryViewModel, BaseViewModel);
export default TicketCategoryViewModel;